import { render, staticRenderFns } from "./DropFile.vue?vue&type=template&id=cfe07c12&scoped=true&"
import script from "./DropFile.vue?vue&type=script&lang=js&"
export * from "./DropFile.vue?vue&type=script&lang=js&"
import style0 from "./DropFile.vue?vue&type=style&index=0&id=cfe07c12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfe07c12",
  null
  
)

export default component.exports